import { nanoid } from "nanoid";
import constants from "../../constants";
import { useContext, useEffect } from "react";
import AlertContext from "../../context/AlertContext";

export default function CodingPageDetailsHooks() {
  const Alert = useContext(AlertContext);

  let details = JSON.parse(JSON.stringify(Alert.assignQnDetailsForLearner));

  useEffect(() => {
    if (Alert.assignQnDetailsForLearner.length !== 0) {
      const handleAssignDetailsToState = () => {
        Alert.setTimeLimit(details?.timelimit);
        Alert.setCodeDetails(details !== null ? details : {});
        console.log("Setting Details for Coding : ",details);
        Alert.setLanguage(
          Alert.status === constants.QUESTION_STATUS.ASSIGNED ||
            Alert.status === constants.QUESTION_STATUS.CONTINUE ||
            Alert.status === constants.QUESTION_STATUS.RESUBMIT ||
            Alert.status === constants.QUESTION_STATUS.REATTEMPT_NEW_VERSION
            ? details?.hasOwnProperty("templatecode") &&
              details.templatecode !== null &&
              details.templatecode.length > 0 &&
              details.templatecode !== undefined
              ? typeof details.templatecode === "string"
                ? JSON.parse(details.templatecode).map((language) => ({
                    value: language.langid,
                    label: language.langname,
                  }))
                : details.templatecode.map((language) => ({
                    value: language.langid,
                    label: language.langname,
                  }))
              : []
            : [{ value: details.langid, label: details.langname }],
        );

        Alert.setSelectedLanguage(
          !details.hasOwnProperty("answer") ||
            Alert.status === constants.QUESTION_STATUS.ASSIGNED ||
            (!Alert.isAdmin &&
              (Alert.status === constants.QUESTION_STATUS.RESUBMIT || Alert.status === constants.QUESTION_STATUS.REATTEMPT_NEW_VERSION)) ||
            (!Alert.isAdmin &&
              Alert.status === constants.QUESTION_STATUS.CONTINUE)
            ? details?.hasOwnProperty("templatecode") &&
              typeof details.templatecode === "string"
              ? {
                  value: JSON.parse(details.templatecode)[0].langid,
                  label: JSON.parse(details.templatecode)[0].langname,
                }
              : {
                  value: details.templatecode[0].langid,
                  label: details.templatecode[0].langname,
                }
            : { value: details.langid, label: details.langname },
        );

        let testCases =
          details?.hasOwnProperty("testcases") &&
          details.testcases !== null &&
          details.testcases !== undefined
            ? JSON.parse(details.testcases)
            : [];

        if (!Alert.isAdmin) {
          testCases = testCases.filter((example) => example.isexample === 1);
        }

        for (let testCase = 0; testCase < testCases.length; testCase++) {
          if (testCase === 0) testCases[testCase].isActive = true;
          testCases[testCase].isSystemTestCase = true;
          testCases[testCase].id = nanoid();
        }

        Alert.testCasesRef.current = testCases;

        Alert.isInputVariable.current =
          Object.values(details).length !== 0 &&
          details.hasOwnProperty("inputvars") &&
          details.inputvars !== "" &&
          details.inputvars !== null &&
          details.inputvars !== undefined &&
          true;

        Alert.setInputVariable(
          Object.values(details).length !== 0 &&
            details.hasOwnProperty("inputvars") &&
            details.inputvars !== null &&
            details.inputvars !== undefined
            ? details.inputvars.split(",")
            : details.testcases !== "[]" &&
                details.testcases !== null &&
                JSON.parse(details.testcases)[0].input.split("\n"),
        );

        Alert.solutionLanguageId.current =
          Object.values(details).length !== 0 &&
          parseInt(details.solutionlangids?.split(",")[0]);

        Alert.setInputVariable(
          details.hasOwnProperty("inputvars") &&
            details.inputvars !== null &&
            details.inputvars !== undefined
            ? details.inputvars.split(",")
            : details.testcases !== "[]" &&
                details.testcases !== null &&
                JSON.parse(details.testcases)[0].input.split("\n"),
        );
        console.log("details.templatecode", details.templatecode, Alert.status);
        
        Alert.setLearnerCode(
          !details.hasOwnProperty("answer") ||
            Alert.status === constants.QUESTION_STATUS.ASSIGNED ||
            (!Alert.isAdmin &&
              (Alert.status === constants.QUESTION_STATUS.RESUBMIT || Alert.status === constants.QUESTION_STATUS.REATTEMPT_NEW_VERSION)) ||
            (!Alert.isAdmin &&
              Alert.status === constants.QUESTION_STATUS.CONTINUE)
            ? details?.hasOwnProperty("templatecode")
              ? typeof details.templatecode === "string"
                ? Alert.testData?.notebook
                  ? JSON.parse(details.templatecode)[0].userCode ??
                    JSON.parse(details.templatecode)[0].usercode ??
                    JSON.parse(details.templatecode)?.[0].code
                  : JSON.parse(details.templatecode)[0]?.templateversion===2
                    ? JSON.parse(details.templatecode)[0].usercode ?? JSON.parse(details.templatecode)?.[0].executioncode
                    : JSON.parse(details.templatecode)[0].usercode ??
                      JSON.parse(details.templatecode)?.[0].code
                : Alert.testData?.notebook
                ? details.templatecode[0]?.userCode ??
                  details.templatecode[0]?.usercode ??
                  details.templatecode[0]?.code
                : details.templatecode[0]?.templateversion===2
                    ?details.templatecode[0].usercode ??details.templatecode?.[0].executioncode
                    : details.templatecode[0]?.usercode ??
                  details.templatecode[0]?.code
              : ""
            : details.answer !== null
            ? details.answer
            : "",
        );

        Alert.setCommentsData(
          Alert.codeDetails?.hasOwnProperty("commentsdata")
            ? Alert.codeDetails.commentsdata
            : [],
        );

        Alert.setScore(Alert.isAdmin ? details.actualscore : 0);
        Alert.setMakeRunTestCase(true);

        /* update testcase */

        Alert.setApproveData({
          qnId: details.qnid,
          marks: details.marks,
          testId: details.testid,
          actualscore: details.actualscore,
        });

        if (!Alert.isAdmin) {
          if (
            details.status === constants.QUESTION_STATUS.SUBMITTED ||
            details.status === constants.QUESTION_STATUS.TO_BE_EVALUATED
          ) {
            Alert.setBreadCrumbsData(details.breadCrumbsData);
          }

          let testCases =
            details?.hasOwnProperty("testcases") &&
            details.testcases !== null &&
            details.testcases !== undefined
              ? JSON.parse(details.testcases)
              : [];

          testCases = testCases.filter((example) => example.isexample === 1);

          for (let i = 0; i < testCases.length; i++) {
            if (i === 0) testCases[i].isActive = true;
            testCases[i].id = nanoid();
          }

          Alert.testCasesRef.current = testCases;
        }

        if (Alert.isAdmin) {
          Alert.setRejectData({
            duration: details.duration,
            timeleft: details.timeleft,
            topicName: details.topicName,
            isFixedQn: details.isFixedQn,
            complexityid: details.complexityid,
            replacedQnTimes: details.replacedQnTimes,
            remainingQnLibrary: details.remainingQnLibrary,
            hasAnyNewVersion: details.hasNewVersion && !details.isFixedQn,
            newVersionQuestions: [{...details}]
          });

          Alert.callAllTestCases.current = true;

          if (details?.hasOwnProperty("commentsdata").length !== 0) {
            Alert.setCommentsData(details.commentsdata);
          }
        }
      };

      handleAssignDetailsToState();
    }
  }, [Alert.assignQnDetailsForLearner]);
}
